import ky from 'ky';

/**
 * Create a `ky` hooks object that will handle authentication.
 */
function createJwtAuthKyHooks(options) {
    var _a;
    const { beforeRequest, afterResponse, ...restHooks } = (_a = options === null || options === void 0 ? void 0 : options.hooks) !== null && _a !== void 0 ? _a : {};
    return {
        beforeRequest: [
            ...beforeRequest !== null && beforeRequest !== void 0 ? beforeRequest : [],
            createJwtAuthKyHookBeforeRequest({ jwtAuth: options === null || options === void 0 ? void 0 : options.jwtAuth }),
        ],
        afterResponse: [
            ...afterResponse !== null && afterResponse !== void 0 ? afterResponse : [],
            createJwtAuthKyHookAfterResponse({ jwtAuth: options === null || options === void 0 ? void 0 : options.jwtAuth }),
        ],
        ...restHooks,
    };
}
/**
 * Create a `ky` beforeRequest hook that will handle initial authentication.
 */
function createJwtAuthKyHookBeforeRequest(options) {
    return async (request, kyOptions) => {
        var _a;
        const jwtAuthInstance = (_a = kyOptions.jwtAuth) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.jwtAuth;
        if (jwtAuthInstance == null) {
            return request;
        }
        return jwtAuthInstance.handleAuth((context) => {
            for (const [name, value] of context.headers) {
                request.headers.set(name, value);
            }
            return new Request(request, {
                // Allow cookies to be sent with the request.
                credentials: 'include',
                // FIXME: Due to the Node.js v18 bug, we need to redundantly set the headers here. Otherwise, the headers will be lost.
                headers: request.headers,
            });
        });
    };
}
/**
 * Create a `ky` afterResponse hook that will catch 401 responses and handle authentication.
 */
function createJwtAuthKyHookAfterResponse(options) {
    return async (request, kyOptions, response) => {
        var _a;
        const jwtAuthInstance = (_a = kyOptions.jwtAuth) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.jwtAuth;
        if (jwtAuthInstance == null) {
            return response;
        }
        if (response.status !== 401) {
            return response;
        }
        return jwtAuthInstance.handleAuth(async (context) => {
            for (const [name, value] of context.headers) {
                request.headers.set(name, value);
            }
            const res = await ky(request, {
                // Allow cookies to be sent with the request.
                credentials: 'include',
                throwHttpErrors: false,
            });
            if (res.status === 401) {
                context.throwAuthErrorIfPossible();
            }
            return res;
        });
    };
}

export { createJwtAuthKyHookAfterResponse, createJwtAuthKyHookBeforeRequest, createJwtAuthKyHooks };
//# sourceMappingURL=ky.mjs.map
